import { DateTime } from "luxon";

const fromNodaTimeZonedDateTime = (dateTimeString: string): DateTime =>
    DateTime.fromFormat(dateTimeString, "yyyy-MM-dd'T'HH:mm:ssZZ z", {
        setZone: true,
    });

const fromIso = (
    dateTimeString?: string,
    checkValidity = true,
): DateTime | undefined => {
    if (!dateTimeString) {
        return undefined;
    }

    const dt = DateTime.fromISO(dateTimeString);
    return !checkValidity || dt.isValid ? dt : undefined;
};

const fromIsoWithFallback = (
    dateTimeString: string | null | undefined,
    fallbackValue: DateTime,
    checkValidity = true,
): DateTime => {
    if (!dateTimeString) {
        return fallbackValue;
    }

    return fromIso(dateTimeString, checkValidity) ?? fallbackValue;
};

const toISO = (dateTime: DateTime | null | undefined): string | undefined => {
    if (!dateTime) {
        return undefined;
    }

    return dateTime.toISO() ?? undefined;
};

export const resetSecondsAndMilliseconds = (dateTime: DateTime) =>
    dateTime.set({ second: 0, millisecond: 0 });

export const luxonUtils = {
    fromNodaTimeZonedDateTime,
    fromIso,
    fromIsoWithFallback,
    toISO,
    resetSecondsAndMilliseconds,
};
